import React from "react";
import ReactDOM from "react-dom/client";

import "./i18n";

import App from "./App";

import { Provider } from "react-redux";
import { configureStore } from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import * as analytics from "./analytics";

// Google Analytics (GA4) — no-op until REACT_APP_GA_MEASUREMENT_ID is set and
// REACT_APP_ANALYTICS_ENABLED is not false. `app` is passed in rather than baked
// into the module so all three portals share the module byte-for-byte.
analytics.init({ app: "admin" });
// Browser RUM (errors, web vitals, browser spans) → Alloy → Loki/Tempo. Separate
// from GA: that measures product usage, this measures whether the app worked.
// Lazy-imported so a portal with RUM off ships none of the SDK.
import("./analytics/rum").then(m => m.initRum("admin")).catch(() => {});

// Silence console output in production builds. (ES imports are hoisted, so this
// runs after module init regardless of source position — keeping it below the
// imports satisfies the `import/first` lint rule with no behavior change.)
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
}

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <Provider store={configureStore({})}>
    <React.Fragment>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);
